import React, { useEffect } from 'react';
import Builder from '../builder/Builder';
export default function Page(_ref) {
  var appProps = _ref.appProps,
    pageTitle = _ref.pageTitle,
    hasBuilderContent = _ref.hasBuilderContent,
    showTitle = _ref.showTitle,
    description = _ref.description,
    visible = _ref.visible;
  useEffect(function () {
    if (new URLSearchParams(window.location.search).has('cnfe') && appProps.translations.account.email_confirmed) {
      // if email got confirmed
      appProps.flashMessage.show(appProps.translations.account.email_confirmed);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, appProps.adminLoggedIn && !visible && /*#__PURE__*/React.createElement("div", {
    className: "flex-box items-center content-center",
    style: {
      width: '100%',
      fontSize: 15,
      textAlign: 'center',
      background: '#eeeeee',
      padding: '10px 20px'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-light fa-circle-exclamation color-scheme"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 10
    }
  }, Store.translations.not_published)), showTitle && /*#__PURE__*/React.createElement("div", {
    className: "heading-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "main-container"
  }, /*#__PURE__*/React.createElement("h1", null, pageTitle))), hasBuilderContent ? /*#__PURE__*/React.createElement(Builder, {
    appProps: appProps
  }) : /*#__PURE__*/React.createElement("div", {
    className: "main-container content-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  })));
}